import React, { Component } from "react";
import PropTypes from 'prop-types';
import Modal from "../Modal";
import { ACCENT_COLOR } from "../../config/colors";

class SmallModal extends Component {
  modalStyle = { border: `3px solid ${ACCENT_COLOR}` };

  getStyle() {
    const {
      style,
    } = this.props;

    return {
      ...{ maxWidth: '600px' },
      ...style,
    };
  }

  render() {
    const {
      content,
    } = this.props;

    return (
      <Modal
        data-qa="small-modal"
        overlayTop={0}
        closeOnOutsideClick={false}
        isOpened
        noOverlay
        onClose={this.onCloseRequest}
        style={this.getStyle()}
      >
        {content}
      </Modal>
    );
  }
}

export default SmallModal;

SmallModal.defaultProps = {
  content: undefined,
  style: undefined,
};

SmallModal.propTypes = {
  content: PropTypes.node,
  style: PropTypes.shape({}),
};



// WEBPACK FOOTER //
// ./src/components/SmallModal/small_modal.jsx